


// import React, { useState } from 'react';
// import axios from 'axios';
// import Llogo from '../Images/lbnlogo.jpeg';
// import { FiUser, FiMail, FiPhone, FiMapPin, FiTrash2 } from "react-icons/fi";

// const UserDelete = () => {
//   const [searchValue, setSearchValue] = useState('');
//   const [userData, setUserData] = useState(null);

//   const fetchUserData = async () => {
//     if (!searchValue) {
//       alert('Please enter email or mobile number');
//       return;
//     }

//     try {
//       const response = await axios.get(
//         `http://localhost:10005/auth-mp/api/user/search?query=${searchValue}`
//       );
//       setUserData(response.data);
//     } catch (error) {
//       setUserData(null);
//       alert('User not found');
//     }
//   };

//   const deleteUser = async () => {
//     const confirmDelete = window.confirm(
//       'Are you sure you want to delete this user? This action cannot be undone.'
//     );

//     if (!confirmDelete) return;

//     try {
//       await axios.delete(
//         `http://localhost:10005/auth-mp/api/user/delete/${userData.id}`
//       );
//       alert('User deleted successfully');
//       setUserData(null);
//       setSearchValue('');
//     } catch (error) {
//       console.error('Delete failed', error);
//       alert('Failed to delete user');
//     }
//   };

//   return (
//     <div style={styles.container}>
//       <header style={styles.header}>
//         <img src={Llogo} alt="Logo" style={styles.logo} />
//         <h1 style={styles.title}>Welcome to LBN Market Place</h1>
//       </header>

//       <div style={styles.content}>
//         <div style={styles.searchContainer}>
//           <input
//             type="text"
//             placeholder="Email or Mobile Number"
//             value={searchValue}
//             onChange={(e) => setSearchValue(e.target.value)}
//             style={styles.input}
//           />
//           <button onClick={fetchUserData} style={styles.buttonPrimary}>
//             Search
//           </button>
//         </div>

//         {userData && (
//           <div style={styles.userCard}>
//             <p><FiUser /> <strong>Name:</strong> {userData.name || 'N/A'}</p>
//             <p><FiMail /> <strong>Email:</strong> {userData.email || 'N/A'}</p>
//             <p><FiPhone /> <strong>Mobile:</strong> {userData.mobile}</p>
//             {userData.city && (
//               <p><FiMapPin /> <strong>City:</strong> {userData.city}</p>
//             )}

//             <button onClick={deleteUser} style={styles.buttonDanger}>
//               <FiTrash2 /> Delete User
//             </button>
//           </div>
//         )}
//       </div>

//       <footer style={styles.footer}>
//         <p>&copy; 2026 LBN Marketplace. All Rights Reserved.</p>
//       </footer>
//     </div>
//   );
// };


// /* Styling */
// const styles = {
//   container: {
//     fontFamily: 'Arial, sans-serif',
//     backgroundColor: '#f4f4f4',
//     minHeight: '100vh',
//     display: 'flex',
//     flexDirection: 'column',
//     justifyContent: 'space-between',
//   },
//   header: {
//     width: '100%',
//     backgroundColor: '#025299', // Navy Blue
//     color: '#faae2f', // Gold
//     padding: '20px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     gap: '10px',
//   },
//   logo: {
//     height: '60px',
//     borderRadius:"10px"
//   },
//   title: {
//     fontSize: '22px',
//     fontWeight: 'bold',
//     textAlign: 'center',
//     flex: 1,
//   },
//   content: {
//     width: '100%',
//     maxWidth: '600px',
//     margin: '20px auto',
//     padding: '20px',
//     backgroundColor: '#fff',
//     borderRadius: '10px',
//     boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
//   },
//   searchContainer: {
//     display: 'flex',
//     justifyContent: 'center',
//     gap: '10px',
//     marginBottom: '20px',
//   },
//   input: {
//     padding: '10px',
//     borderRadius: '5px',
//     border: '1px solid #ccc',
//     width: '70%',
//   },
//   buttonPrimary: {
//     backgroundColor: '#025299',
//     color: 'white',
//     padding: '10px 20px',
//     border: 'none',
//     borderRadius: '5px',
//     cursor: 'pointer',
//     fontWeight: 'bold',
//   },
//   buttonDanger: {
//     backgroundColor: '#DC143C',
//     color: 'white',
//     padding: '10px 20px',
//     border: 'none',
//     borderRadius: '5px',
//     cursor: 'pointer',
//     marginTop: '10px',
//     fontWeight: 'bold',
//   },
//   buttonDanger: {
//     backgroundColor: '#DC143C',
//     color: 'white',
//     padding: '10px 20px',
//     border: 'none',
//     borderRadius: '5px',
//     cursor: 'pointer',
//     marginTop: '10px',
//     fontWeight: 'bold',
//   },
//   buttonSuccess: {
//     backgroundColor: '#DC143C',
//     color: 'white',
//     padding: '10px 20px',
//     border: 'none',
//     borderRadius: '5px',
//     cursor: 'pointer',
//     fontWeight: 'bold',
//   },
//   userCard: {
//     marginTop: '20px',
//     padding: '25px',
//     borderRadius: '12px',
//     background: 'linear-gradient(135deg, #025299, #001a44)', // Navy Blue Gradient
//     color: '#ffffff', // Gold Text
//     boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.2)',
//     display:'flex',
//     flexDirection:"column",
//     alignItems:'flex-start'
   
//   },
//   cardTitle: {
//     fontSize: '22px',
//     fontWeight: 'bold',
//     marginBottom: '15px',
//     borderBottom: '2px solid #faae2f',
//     display: 'inline-block',
//     paddingBottom: '5px',
//   },
//   userInfo: {
//     fontSize: '18px',
//     lineHeight: '1.8',
//     display: 'flex',
//     flexDirection: 'column',

//   },
//   icon: {
//     marginRight: '8px',
//     color: '#faae2f', // Gold color
//     fontSize: '20px',
//   },
//   iconButton: {
//     marginRight: '5px',
//     fontSize: '18px',
//   },
//   buttonDanger: {
//     backgroundColor: '#dc3545',
//     color: 'white',
//     padding: '12px 25px',
//     border: 'none',
//     borderRadius: '8px',
//     cursor: 'pointer',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     fontSize: '16px',
//     fontWeight: 'bold',
//     transition: 'background 0.3s ease, transform 0.2s',
//     marginTop: '20px',
//     boxShadow: '0px 4px 10px rgba(255, 0, 0, 0.3)',
//   },
//   buttonDangerHover: {
//     backgroundColor: '#b22222',
//     transform: 'scale(1.05)',
//   },
//   otpContainer: {
//     marginTop: '20px',
//     textAlign: 'center',
//   },
//   footer: {
//     width: '100%',
//     backgroundColor: '#025299',
//     color: '#faae2f',
//     padding: '15px',
//     textAlign: 'center',
//     fontWeight: 'bold',
//   },
// };

// export default UserDelete;


import React, { useState } from 'react';
import axios from 'axios';
import Llogo from '../Images/lbnlogo.jpeg';
import { FiUser, FiMail, FiPhone, FiMapPin, FiTrash2, FiSearch } from "react-icons/fi";

const UserDelete = () => {
  const [searchValue, setSearchValue] = useState('');
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchUserData = async () => {
    if (!searchValue) {
      alert('Please enter email or mobile number');
      return;
    }
    setLoading(true);
    try {
      const response = await axios.get(
        `https://api.lbnhyderabad.com/auth-mp/api/user/search?query=${searchValue}`
      );
      setUserData(response.data);
    } catch (error) {
      setUserData(null);
      alert('User not found');
    } finally {
      setLoading(false);
    }
  };

  const deleteUser = async () => {
    const confirmDelete = window.confirm(
      'Are you sure you want to delete this user? This action cannot be undone.'
    );

    if (!confirmDelete) return;

    try {
      await axios.delete(
        `https://api.lbnhyderabad.com/auth-mp/api/user/delete/${userData.id}`
      );
      alert('User deleted successfully');
      setUserData(null);
      setSearchValue('');
    } catch (error) {
      console.error('Delete failed', error);
      alert('Failed to delete user');
    }
  };

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <div style={styles.headerContent}>
          <img src={Llogo} alt="Logo" style={styles.logo} />
          <h1 style={styles.title}>LBN <span style={{ color: '#fff' }}>Marketplace</span></h1>
        </div>
      </header>

      <main style={styles.content}>
        <div style={styles.glassCard}>
          <h2 style={styles.sectionTitle}>User Delete Management</h2>
          <p style={styles.subtitle}>Search for a user account to perform Delete actions.</p>
          
          <div style={styles.searchWrapper}>
            <div style={styles.inputContainer}>
              <FiSearch style={styles.searchIcon} />
              <input
                type="text"
                placeholder="Email or Mobile Number"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                style={styles.input}
              />
            </div>
            <button 
              onClick={fetchUserData} 
              style={styles.buttonPrimary}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#013a6d'}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#025299'}
            >
              {loading ? 'Searching...' : 'Search User'}
            </button>
          </div>
        </div>

        {userData && (
          <div style={styles.userCard}>
            <div style={styles.cardHeader}>
              <div style={styles.avatarCircle}>
                {userData.name ? userData.name.charAt(0).toUpperCase() : 'U'}
              </div>
              <h3 style={styles.cardName}>{userData.name || 'Anonymous User'}</h3>
            </div>
            
            <div style={styles.detailsGrid}>
              <div style={styles.detailItem}>
                <FiMail style={styles.icon} />
                <div>
                  <label style={styles.label}>Email Address</label>
                  <p style={styles.infoText}>{userData.email || 'N/A'}</p>
                </div>
              </div>
              <div style={styles.detailItem}>
                <FiPhone style={styles.icon} />
                <div>
                  <label style={styles.label}>Phone Number</label>
                  <p style={styles.infoText}>{userData.mobile}</p>
                </div>
              </div>
              {userData.city && (
                <div style={styles.detailItem}>
                  <FiMapPin style={styles.icon} />
                  <div>
                    <label style={styles.label}>Location</label>
                    <p style={styles.infoText}>{userData.city}</p>
                  </div>
                </div>
              )}
            </div>

            <button 
              onClick={deleteUser} 
              style={styles.buttonDanger}
              onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
              onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <FiTrash2 style={{ marginRight: '8px' }} /> Delete User Account
            </button>
          </div>
        )}
      </main>

      <footer style={styles.footer}>
        <p>&copy; 2026 LBN Marketplace • Admin Portal</p>
      </footer>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    backgroundColor: '#f0f2f5',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    background: 'linear-gradient(90deg, #025299 0%, #003366 100%)',
    padding: '15px 40px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
  },
  headerContent: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
  },
  logo: {
    height: '50px',
    borderRadius: '8px',
    border: '2px solid #faae2f',
  },
  title: {
    fontSize: '24px',
    fontWeight: '800',
    color: '#faae2f',
    letterSpacing: '0.5px',
    margin: 0,
  },
  content: {
    flex: 1,
    padding: '40px 20px',
    maxWidth: '800px',
    width: '100%',
    margin: '0 auto',
  },
  glassCard: {
    background: '#fff',
    padding: '30px',
    borderRadius: '16px',
    boxShadow: '0 10px 25px rgba(0,0,0,0.05)',
    marginBottom: '30px',
  },
  sectionTitle: {
    fontSize: '22px',
    color: '#333',
    marginBottom: '8px',
  },
  subtitle: {
    color: '#666',
    fontSize: '14px',
    marginBottom: '25px',
  },
  searchWrapper: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
  },
  inputContainer: {
    flex: 1,
    position: 'relative',
    minWidth: '250px',
  },
  searchIcon: {
    position: 'absolute',
    left: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#999',
  },
  input: {
    width: '100%',
    padding: '12px 12px 12px 40px',
    borderRadius: '10px',
    border: '1.5px solid #e1e1e1',
    fontSize: '16px',
    outline: 'none',
    transition: 'border-color 0.3s',
    boxSizing: 'border-box',
  },
  buttonPrimary: {
    backgroundColor: '#025299',
    color: 'white',
    padding: '12px 28px',
    border: 'none',
    borderRadius: '10px',
    cursor: 'pointer',
    fontWeight: '600',
    fontSize: '15px',
    transition: 'all 0.3s ease',
  },
  userCard: {
    background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
    borderRadius: '20px',
    padding: '30px',
    boxShadow: '0 20px 40px rgba(0,0,0,0.08)',
    border: '1px solid rgba(255,255,255,0.8)',
    animation: 'slideUp 0.5s ease-out',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    marginBottom: '25px',
    borderBottom: '1px solid #eee',
    paddingBottom: '20px',
  },
  avatarCircle: {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    backgroundColor: '#faae2f',
    color: '#025299',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    fontWeight: 'bold',
    boxShadow: '0 4px 10px rgba(250, 174, 47, 0.3)',
  },
  cardName: {
    fontSize: '22px',
    color: '#025299',
    margin: 0,
  },
  detailsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '20px',
    marginBottom: '30px',
  },
  detailItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
  },
  icon: {
    marginTop: '4px',
    color: '#025299',
    fontSize: '18px',
  },
  label: {
    display: 'block',
    fontSize: '12px',
    textTransform: 'uppercase',
    color: '#999',
    fontWeight: '700',
    marginBottom: '2px',
  },
  infoText: {
    fontSize: '16px',
    color: '#333',
    margin: 0,
    fontWeight: '500',
  },
  buttonDanger: {
    width: '100%',
    backgroundColor: '#ff4d4f',
    color: 'white',
    padding: '14px',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 14px rgba(255, 77, 79, 0.3)',
  },
  footer: {
    padding: '25px',
    textAlign: 'center',
    color: '#888',
    fontSize: '14px',
  },
};

export default UserDelete;